export default "/images/crypto_environments/ethereum_audit_1.png";